import { SVG, SVGProps } from './svg'

export function IconIdea(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M19 9a7 7 0 00-7-7h-.1C8.2 2.1 5.2 5 5 8.7a7 7 0 003 6c.7.4 1 1 1 1.8v.5c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-.5a2 2 0 011-1.7A7 7 0 0019 9zm-4.2 4.1a4 4 0 00-1.5 1.9h-2.6a4 4 0 00-1.5-1.9A5 5 0 017 8.8 5.1 5.1 0 0112 4a5 5 0 012.8 9.1zm-4.5 8.2a1 1 0 01-.3-.7V20h4v.6c0 .3-.1.5-.3.7l-.4.4a1 1 0 01-.7.3h-1.2a1 1 0 01-.7-.3l-.4-.4z"
      />
    </SVG>
  )
}
